import { ChassisType, ChassisModelTypes, ChassisSeriesTypes, ChassisPassengerCapacities } from "../../../../../@types/ChassisType";
import assets from "../../../../../assets";

// E4 products temporarily used while handling this model
// this model is really only currently supported for warranty registrations and claims
import { ChassisBatteryConfigs } from "../E4/E4Products/ChassisBatteryConfigs";
import Tops from "../E4/E4Products/Tops";

// Shared Products between ESeries Chassis
import BodyColorsE4 from "../Shared/BodyColors";
import { LiftKitsE4 } from "../Shared/LiftKit";
import Batteries from "../Shared/Batteries";
import {
    Wheels12In,
    Wheels12InLifted,
    WheelSizeOptions
} from "../Shared/Wheels";
import LugNuts from "../../Shared/LugNuts";
import { Tires12In, Tires12InLifted } from "../Shared/Tires";
import { LsvKit } from "../Shared/LsvKit";
import { FrontSeats, RearSeats } from "../Shared/Seats";
import SeatFrames from "../Shared/SeatFrames";
import { AccessoriesESeries, AccessoriesESeriesLifted, AccessoriesESeriesOptional, AccessoriesESeriesOptionalNonLifted } from "../../Shared/Accessories";
import WindShields from "../Shared/Windshields";



export const E2Shuttle: ChassisType = {
    id: `${ChassisModelTypes.E2Shuttle}-2025`,
    sku: `${ChassisModelTypes.E2Shuttle}-2025`,
    series: ChassisSeriesTypes.ESeries,
    categoryName: 'ESeries',
    name: `2025 ESeries E2 Shuttle 2 Passenger`,
    year: 2024,
    model: ChassisModelTypes.E2Shuttle,
    logo: assets.images.chassisLogo.e4,
    passengerCapacity: ChassisPassengerCapacities["2 Passenger"],
    price: 5365,
    retailPrice: 8995,
    marketingSlogan: 
    `More Thrills. Less Bills`,
    bodyColorOptions: BodyColorsE4,
    liftKitOptions: LiftKitsE4,
    chassisBatteryConfigOptions: ChassisBatteryConfigs,
    chassisBatteryOptions: Batteries,
    wheelSizeOptions: WheelSizeOptions,
    wheelOptions: Wheels12In,
    wheelOptionsLifted: Wheels12InLifted,
    lugNutOptions: LugNuts,
    tireOptions: Tires12In,
    tireOptionsLifted: Tires12InLifted,
    lsvKitOptions: LsvKit,
    topOptions: Tops,
    windshieldOptions: WindShields,
    frontSeatOptions: FrontSeats,
    rearSeatOptions: RearSeats,
    seatFrameOptions: SeatFrames,
    preassembled: false,
    allowInternationalPurchase: true,
    includedAccessories: AccessoriesESeries,
    includedAccessoriesLifted: AccessoriesESeriesLifted,
    optionalAccessories: [...AccessoriesESeriesOptional, ...AccessoriesESeriesOptionalNonLifted],
    optionalAccessoriesLifted: AccessoriesESeriesOptional
}